import { render } from "./svg.vue?vue&type=template&id=349a187e&scoped=true"
import script from "./svg.vue?vue&type=script&lang=js"
export * from "./svg.vue?vue&type=script&lang=js"

import "./svg.vue?vue&type=style&index=0&id=349a187e&scoped=true&lang=css"

import exportComponent from "/builds/PRD00329/YTSONLINEWORD/doconline-doc-pc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-349a187e"]])

export default __exports__